import { z } from 'zod';
/**
 * A single "map a source field to a display column" row, scoped to which
 * entity type(s) it applies to. This is a generic, reusable primitive — not
 * tied to any one feature — for any Json feature that needs a brand/agent
 * configurable table-column mapping (Smart Routing's custom columns today;
 * potentially other entity tables later).
 */
export const EntityColumnMappingSchema = z.object({
    sourceField: z.string().min(1),
    displayName: z.string().min(1),
    validEntities: z.array(z.enum(['hcp', 'account'])).min(1),
});
